import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MyBookingPassengerService } from '@common/services/my-booking/my-booking-passenger/my-booking-passenger.service';
import { ButtonModule } from '@lib/components';
import { StaticMsgModule } from '@lib/pipes';
import { MyBookingMenuModule } from '../../menu-modal/menu.module';
import { InformationsDuringStayModule } from '../sub-components/informations-during-stay/informations-during-stay.module';
import { PassengerInformationModule } from '../sub-components/passenger-information/passenger-information.module';
import { RepresentiveContactsModule } from '../sub-components/representive-contacts/representive-contacts.module';
import { UpgradeNotificationModule } from '../sub-components/upgrade-notification/upgrade-notification.module';
import { MyBookingPassengerPresComponent } from './my-booking-passenger-pres.component';
import { TealiumModule } from '@common/components/tealium/tealium.module';
import { MyBookingSlidebarMenuModule } from '@app/my-booking/sub-components/my-booking-slidebar-menu/my-booking-slidebar-menu.module';

@NgModule({
  declarations: [MyBookingPassengerPresComponent],
  imports: [
    CommonModule,
    RepresentiveContactsModule,
    PassengerInformationModule,
    InformationsDuringStayModule,
    ButtonModule,
    UpgradeNotificationModule,
    MyBookingMenuModule,
    StaticMsgModule,
    TealiumModule,
    MyBookingSlidebarMenuModule,
  ],
  providers: [MyBookingPassengerService],
  exports: [MyBookingPassengerPresComponent],
})
export class MyBookingPassengerPresModule {}
